<div class="container d-flex justify-content-center align-items-center min-vh-100">
  <div class="align-items-center">
    <div class="title text-center mb-2"><img src="./assets/img/lupa.png" alt="Lupa" class="custom-margin" />

      <p>En SURA, el estudio financiero <br> de tu inquilino no tiene costo.</p>
    </div>

    <div class="d-grid gap-4">
      <div class="step text-center" *ngFor="let step of steps; let i = index">
        <p>{{step.title}}</p>
        <img [src]="step.imageUrl" [class]="step.loading ? 'spinner' : ''" [alt]="step.loading ? 'Cargando' : 'check32'" />
      </div>
    </div>
  </div>
</div>
